import { render } from "./BayPricingManagement.vue?vue&type=template&id=16b8dd63&scoped=true"
import script from "./BayPricingManagement.vue?vue&type=script&lang=js"
export * from "./BayPricingManagement.vue?vue&type=script&lang=js"

import "./BayPricingManagement.vue?vue&type=style&index=0&id=16b8dd63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b8dd63"]])

export default __exports__